/* hgn-shop-mode.js — moved verbatim from snippets/hgn-shop-mode.liquid on 2026-09-14 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 1 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';

  if (window.HGN && window.HGN.shopMode) return;

  var MODES = ['shop', 'kit', 'drop'];
  var STORAGE_PREFIX = 'hgn-shop-mode:';
  var TESTER_KEY = 'hgn-drop-tester';
  var TESTER_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days — mirrors kit's dismiss TTL

  /* Same customer-id resolution as hgn-kit-progress.liquid so the
     two stores key identically for a given shopper. */
  function currentCustomerId() {
    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
      return String(window.Shopify.customer.id);
    }
    var node = document.querySelector('[data-customer-id]');
    if (node) {
      var id = node.getAttribute('data-customer-id');
      if (id && id !== 'anon') return id;
    }
    return 'anon';
  }
  function storageKey() {
    return STORAGE_PREFIX + currentCustomerId();
  }

  /* ───── Tester flag (?hgn_drop=1 → 7-day localStorage window) ───── */
  function hasTesterFlag() {
    try {
      var v = localStorage.getItem(TESTER_KEY);
      var until = v ? parseInt(v, 10) : 0;
      if (!isFinite(until) || until <= 0) return false;
      if (Date.now() < until) return true;
      /* Expired — clean up so the key doesn't linger (mirrors the
         kit toggle's dismiss-flag expiry sweep). */
      localStorage.removeItem(TESTER_KEY);
      return false;
    } catch (e) { return false; }
  }
  function setTesterFlag() {
    try { localStorage.setItem(TESTER_KEY, String(Date.now() + TESTER_TTL_MS)); }
    catch (e) {}
  }
  /* URL param write — runs once at script init, same placement as the
     kit toggle's UTM-intent override. The param ALSO flips drop mode
     on, but that's collection-chrome's job (maybeBootFromDropUtm) so
     the boot ordering matches the kit UTM flow exactly. */
  try {
    var qs = new URLSearchParams(window.location.search || '');
    if (qs.get('hgn_drop') === '1') setTesterFlag();
  } catch (e) {}

  /* ───── Availability gate ─────
     Evaluated lazily on every call (the announcement bar that emits
     HGN_DROP_LIVE / HGN_DROP_ENABLED renders after this snippet).
     - HGN_DROP_ENABLED absent → the Drop-aware announcement section
       isn't deployed → unavailable (protects a partial deploy).
     - Market gate: at least one tier not explicitly false (raw
       `| json` booleans — null/undefined/true all count as enabled,
       same rule as HGN_KIT_ENABLED).
     - Launch gate: HGN_DROP_LIVE === true, or the tester flag. */
  function isDropAvailable() {
    var enabled = window.HGN_DROP_ENABLED;
    if (!enabled || typeof enabled !== 'object') return false;
    var anyTier = false;
    for (var k in enabled) {
      if (Object.prototype.hasOwnProperty.call(enabled, k) && enabled[k] !== false) {
        anyTier = true;
        break;
      }
    }
    if (!anyTier) return false;
    if (window.HGN_DROP_LIVE === true) return true;
    return hasTesterFlag();
  }

  /* ───── Storage ───── */
  function readStored() {
    try {
      var raw = localStorage.getItem(storageKey());
      return MODES.indexOf(raw) !== -1 ? raw : 'shop';
    } catch (e) { return 'shop'; }
  }
  function writeStored(mode) {
    try { localStorage.setItem(storageKey(), mode); } catch (e) {}
  }

  function getKp() {
    return (window.HGN && window.HGN.kitProgress) ? window.HGN.kitProgress : null;
  }

  /* Derived mode — kit-progress is authoritative for 'kit' (its
     switch can be flipped by the kit-bar, UTM boots, another tab…
     without going through this module); localStorage is authoritative
     for 'drop', degraded to 'shop' whenever the gate is closed
     (tester expiry, market disable, flag pulled — mirrors
     kit-progress's disabled-tier defensive getFocus()). */
  function get() {
    var kp = getKp();
    try {
      if (kp && typeof kp.getKitBuildMode === 'function' &&
          kp.getKitBuildMode() === 'on') {
        return 'kit';
      }
    } catch (e) {}
    var stored = readStored();
    if (stored === 'drop' && isDropAvailable()) return 'drop';
    return 'shop';
  }

  function applyBodyClass(mode) {
    if (!document || !document.body) return;
    document.body.classList.toggle('hgn-drop-active', mode === 'drop');
  }

  function emitChange(from, to, source) {
    try {
      document.dispatchEvent(new CustomEvent('hgn:shop-mode:change', {
        detail: { from: from, to: to, source: source || null }
      }));
    } catch (e) {}
  }

  /* Persist + broadcast one transition. Idempotent on the stored
     value but always re-applies the body class (belt-and-braces for
     the head-renders-before-body race, same reasoning as
     kit-progress's applyBuildModeBodyClass re-syncs). */
  function commit(from, to, source) {
    writeStored(to);
    applyBodyClass(to);
    if (from !== to) emitChange(from, to, source);
  }

  /* Reconciliation guard — while set() is orchestrating a transition
     the kit-build-mode listener below must not double-commit. */
  var transitioning = false;

  /* ───── Nail Drop copy + pricing helpers (R1/R2) ─────
     Copy resolution mirrors the toggle's copyOr: merchant strings
     from HGN_DROP_COPY (announcement schema), JS defaults otherwise. */
  function dropCopy(key, fallback) {
    var c = window.HGN_DROP_COPY || {};
    var v = c[key];
    return (v == null || v === '') ? fallback : v;
  }
  var DROP_TIERS = ['classic', 'gels', 'press-ons'];
  var LANE_NAME = {
    classic:     'Classic Nail Drop',
    gels:        'Gel Nail Drop',
    'press-ons': 'Press-On Nail Drop'
  };
  var LANE_NOUN = {
    classic:     'Classic Wraps',
    gels:        'Gel Wraps',
    'press-ons': 'Press-On sets'
  };
  /* Per-box price in the visitor's currency — HGN_DROP_PRICES is GBP
     canonical; display always goes through HGN.formatLive (same
     pattern as the kit bundle prices). Empty string when unpriced. */
  function formatDropPrice(tier) {
    var prices = window.HGN_DROP_PRICES || {};
    var gbp = prices[tier];
    if (typeof gbp !== 'number' || !(gbp > 0)) return '';
    try {
      if (window.HGN && typeof window.HGN.formatLive === 'function' &&
          typeof window.HGN.activeCurrencyKey === 'function') {
        return window.HGN.formatLive(gbp, window.HGN.activeCurrencyKey());
      }
    } catch (e) {}
    return '£' + gbp.toFixed(2);
  }
  function dropCount(tier) {
    var m = window.HGN_DROP_COUNTS || { classic: 4, gels: 3, 'press-ons': 2 };
    var n = parseInt(m[tier], 10);
    return (isFinite(n) && n > 0) ? n : 0;
  }

  /* ───── Nail Drop entry modal (R2 — kitFocusModal peer) ─────
     DOM is built lazily on first show (this snippet renders in <head>
     before <body> exists). Markup / class structure mirrors
     `.hgn-kit-focus-modal` in hgn-kit-bar.liquid; styles live in
     assets/hgn-drop.css. */
  var laneModalEl = null;
  var laneActiveResolver = null;

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function buildLaneModal() {
    if (laneModalEl) return laneModalEl;
    var el = document.createElement('div');
    el.className = 'hgn-drop-lane-modal';
    el.setAttribute('data-hgn-drop-lane-modal', '');
    el.hidden = true;
    var rowsHtml = DROP_TIERS.map(function (tier) {
      return '<li data-hgn-drop-lane-row="' + tier + '">' +
        '<button type="button" class="hgn-drop-lane-option" data-hgn-drop-lane-pick="' + tier + '">' +
          '<span class="hgn-drop-lane-option__name">' + escapeHtml(LANE_NAME[tier]) + '</span>' +
          '<span class="hgn-drop-lane-option__pitch" data-hgn-drop-lane-pitch></span>' +
          '<span class="hgn-drop-lane-option__sub" data-hgn-drop-lane-sub></span>' +
          '<span class="hgn-drop-lane-option__pref" data-hgn-drop-lane-pref></span>' +
        '</button>' +
      '</li>';
    }).join('');
    el.innerHTML =
      '<div class="hgn-drop-lane-modal__scrim" data-hgn-drop-lane-cancel></div>' +
      '<div class="hgn-drop-lane-modal__panel" role="dialog" aria-modal="true" aria-labelledby="hgn-drop-lane-title">' +
        '<button type="button" class="hgn-drop-lane-modal__close" data-hgn-drop-lane-cancel aria-label="Close">' +
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">' +
            '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<header class="hgn-drop-lane-modal__head">' +
          '<p class="hgn-drop-lane-modal__eyebrow">' + escapeHtml(dropCopy('modalEyebrow', 'Nail Drop')) + '</p>' +
          '<h2 class="hgn-drop-lane-modal__title" id="hgn-drop-lane-title">' +
            escapeHtml(dropCopy('modalTitle', 'Which Nail Drop is yours?')) +
          '</h2>' +
          '<p class="hgn-drop-lane-modal__copy">' +
            escapeHtml(dropCopy('modalCopy', 'Pick your lane — every box is your tier only, in the order you choose (smart-filled from your taste if you run low). Change frequency, skip or cancel anytime.')) +
          '</p>' +
        '</header>' +
        '<ul class="hgn-drop-lane-modal__options" data-hgn-drop-lane-options>' + rowsHtml + '</ul>' +
      '</div>';
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-hgn-drop-lane-cancel]')) {
        closeLaneModal('__cancel__');
        return;
      }
      var pick = e.target.closest('[data-hgn-drop-lane-pick]');
      if (pick) closeLaneModal(pick.getAttribute('data-hgn-drop-lane-pick'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && laneModalEl && !laneModalEl.hidden) {
        closeLaneModal('__cancel__');
      }
    });
    document.body.appendChild(el);
    laneModalEl = el;
    return el;
  }

  /* Per-show render: pitch (counts + price + savings line), live
     "{n} queued" pre-queue counts, per-market disabled tiers hidden
     (mirror of renderFocusOptions' late-gate). */
  function renderLaneOptions() {
    if (!laneModalEl) return;
    var dq = window.HGN && window.HGN.dropQueue;
    var pitchTpl = dropCopy('modalPitch',
      '{count} {noun} every 4–8 weeks · {price} per box · ~25% off + free gifts');
    var counts = { classic: 0, gels: 0, 'press-ons': 0 };
    if (dq && typeof dq.getQueue === 'function') {
      dq.getQueue().forEach(function (it) {
        if (counts[it.tier] != null) counts[it.tier] += 1;
      });
    }
    DROP_TIERS.forEach(function (tier) {
      var row = laneModalEl.querySelector('[data-hgn-drop-lane-row="' + tier + '"]');
      if (!row) return;
      var enabled = !dq || typeof dq.isTierEnabled !== 'function' || dq.isTierEnabled(tier);
      row.hidden = !enabled;
      if (!enabled) return;
      var pitch = row.querySelector('[data-hgn-drop-lane-pitch]');
      if (pitch) {
        pitch.textContent = String(pitchTpl)
          .split('{count}').join(String(dropCount(tier) || ''))
          .split('{noun}').join(LANE_NOUN[tier] || 'designs')
          .split('{price}').join(formatDropPrice(tier) || '');
      }
      var sub = row.querySelector('[data-hgn-drop-lane-sub]');
      if (sub) {
        sub.textContent = counts[tier] > 0 ? (counts[tier] + ' queued') : '';
      }
      /* P5.5 Wide Fit — the panel reflects the gate the queue enforces:
         a classic lane constrained by the shopper's preference says so
         up front (control-first; the preference is theirs to change in
         the wizard). */
      var pref = row.querySelector('[data-hgn-drop-lane-pref]');
      if (pref) {
        var wf = (tier === 'classic' && dq && typeof dq.getWideFitPref === 'function')
          ? dq.getWideFitPref() : 'any';
        pref.textContent = wf === 'only'
          ? 'Wide Fit wraps only — your preference'
          : wf === 'none' ? 'No Wide Fit wraps — your preference' : '';
      }
    });
  }

  function closeLaneModal(result) {
    if (laneModalEl) laneModalEl.hidden = true;
    if (laneActiveResolver) {
      var r = laneActiveResolver;
      laneActiveResolver = null;
      r(result);
    }
  }

  var dropLaneModal = {
    show: function () {
      if (!document.body) return Promise.resolve('__cancel__');
      buildLaneModal();
      /* A previous show() still open → resolve it cancelled, replace. */
      if (laneActiveResolver) {
        var prev = laneActiveResolver;
        laneActiveResolver = null;
        prev('__cancel__');
      }
      renderLaneOptions();
      laneModalEl.hidden = false;
      return new Promise(function (resolve) { laneActiveResolver = resolve; });
    },
    close: function () { closeLaneModal('__cancel__'); }
  };

  /* ───── Enter drop mode (R2 lane gate) ─────
     Order: hydrate subscriber state (lazy cached GET — guests resolve
     null with no network) → lane = subscriber tier, or opts.lane
     (which OVERRIDES a stored lane for non-subscribers — fix F3a: an
     explicit deep-link tier is fresh intent), or stored focus → no
     lane → mandatory entry modal. Only a resolved lane commits the
     mode; cancel bounces back. `transitioning` is held until the
     outcome so the kit-sync reconciler can't double-commit.

     ORDERING (fix F2): commit BEFORE setFocus on the modal path —
     the collection-chrome route listener for hgn:drop:focus:change is
     gated on dropModeOn(), so focus-first left modal picks on the
     wrong collection stranded with nothing painted. Mode-before-focus
     mirrors kit-progress's setKitBuildMode write-the-flag-upfront
     ordering (its focus-redirect race comment). The opts.lane path
     necessarily sets focus first (laneless drop mode is forbidden);
     its routing is owned by the UTM-boot caller. */
  function enterDrop(from, opts) {
    var dq = window.HGN && window.HGN.dropQueue;
    var prep = (dq && typeof dq.getSubscriberState === 'function')
      ? dq.getSubscriberState()
      : Promise.resolve(null);
    return prep.then(function () {
      var sub = (dq && typeof dq.getSubscriber === 'function') ? dq.getSubscriber() : null;
      if (opts.lane && !sub && dq && typeof dq.setFocus === 'function') {
        dq.setFocus(opts.lane); // refuses invalid / market-disabled tiers
      }
      var lane = (dq && typeof dq.getFocus === 'function') ? dq.getFocus() : null;
      if (lane || opts.skipLaneModal) {
        transitioning = false;
        commit(from, 'drop', opts.source);
        return { ok: true, changed: true, mode: 'drop' };
      }
      return dropLaneModal.show({ source: opts.source || 'set-shop-mode' })
        .then(function (picked) {
          transitioning = false;
          if (!picked || picked === '__cancel__') {
            return { ok: true, changed: false, mode: get(), cancelled: true };
          }
          commit(from, 'drop', opts.source);
          if (dq && typeof dq.setFocus === 'function') dq.setFocus(picked);
          return { ok: true, changed: true, mode: 'drop' };
        });
    });
  }

  /* Leave kit mode via the CANONICAL off flow. With zero picks the
     flip is silent; with picks the kit-bar's off-confirm modal owns
     the interaction (same hand-off order as the shared toggle:
     kit-bar switch input first, openKitOffModal fallback, direct
     setKitBuildMode last resort). Resolution comes from the kit
     event stream:
       hgn:kit-build-mode:change {to:'off'} → left
       hgn:kit-off:cancelled               → shopper backed out
       hgn:kit-build-mode:blocked          → migration failed, mode
                                             stays ON (picks intact) */
  function leaveKit(opts) {
    var kp = getKp();
    if (!kp || typeof kp.getKitBuildMode !== 'function' ||
        kp.getKitBuildMode() !== 'on') {
      return Promise.resolve({ ok: true });
    }
    var source = (opts && opts.source) || 'shop-mode';
    var picks = (typeof kp.totalKitPicks === 'function') ? kp.totalKitPicks() : 0;
    if (picks === 0) {
      return kp.setKitBuildMode('off', { source: source + '-no-picks' })
        .then(function (res) {
          return { ok: !(res && res.ok === false) };
        });
    }
    return new Promise(function (resolve) {
      var settled = false;
      function finish(result) {
        if (settled) return;
        settled = true;
        document.removeEventListener('hgn:kit-build-mode:change', onChange);
        document.removeEventListener('hgn:kit-off:cancelled', onCancel);
        document.removeEventListener('hgn:kit-build-mode:blocked', onBlocked);
        resolve(result);
      }
      function onChange(e) {
        if (e.detail && e.detail.to === 'off') finish({ ok: true });
      }
      function onCancel() { finish({ ok: true, cancelled: true }); }
      function onBlocked() { finish({ ok: false }); }
      document.addEventListener('hgn:kit-build-mode:change', onChange);
      document.addEventListener('hgn:kit-off:cancelled', onCancel);
      document.addEventListener('hgn:kit-build-mode:blocked', onBlocked);

      var barInput = document.querySelector('[data-hgn-kit-bar-switch-input]');
      if (barInput && barInput.checked) {
        barInput.checked = false;
        barInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (window.HGN && typeof window.HGN.openKitOffModal === 'function') {
        window.HGN.openKitOffModal({ source: source, cancelSource: source });
      } else {
        /* No modal surface on this page — flip directly; kit-progress
           runs the kit→cart migration itself. */
        kp.setKitBuildMode('off', { source: source }).then(function (res) {
          finish({ ok: !(res && res.ok === false) });
        });
      }
    });
  }

  /* ───── set(mode, opts) ─────
     Always returns a Promise (mirrors kp.setKitBuildMode). Resolves
     { ok, changed, mode, cancelled? } — `cancelled: true` means a kit
     modal (focus picker or off-confirm) was dismissed and callers
     should bounce their control back to the previous mode. */
  function set(target, opts) {
    opts = opts || {};
    /* Fix F5: a pending lane modal from an earlier set() must never
       outlive a newer intent — resolve it cancelled up front so a
       late pick can't stomp whatever the shopper chose since (e.g.
       an active kit build). Re-entry paths below open a fresh one. */
    closeLaneModal('__cancel__');
    if (MODES.indexOf(target) === -1) {
      return Promise.resolve({ ok: false, changed: false, mode: get() });
    }
    var current = get();
    if (target === current) {
      /* Fix P3: get() degrades stored 'drop' to 'shop' while the gate
         is closed — an explicit set('shop') should still scrub the
         stale stored 'drop' so a later re-enable doesn't resurrect
         drop mode unasked. Silent write: observable mode unchanged. */
      if (target === 'shop' && readStored() !== 'shop') {
        writeStored('shop');
      }
      /* Fix F3b — Drop's "Change kit" equivalent: re-selecting the
         ACTIVE Nail Drop segment reopens the lane modal for
         NON-subscribers. A new pick keeps the mode and just moves the
         lane (setFocus → hgn:drop:focus:change repaints the tier lock
         + routes to the new lane's canonical); cancel is a no-op.
         Subscribers stay contract-locked (tier switching = Appstle
         Swap, P6). */
      if (target === 'drop') {
        var dqCl = window.HGN && window.HGN.dropQueue;
        var subCl = (dqCl && typeof dqCl.getSubscriber === 'function') ? dqCl.getSubscriber() : null;
        if (!subCl) {
          return dropLaneModal.show({ source: opts.source || 'change-lane' })
            .then(function (picked) {
              if (picked && picked !== '__cancel__' &&
                  dqCl && typeof dqCl.setFocus === 'function') {
                dqCl.setFocus(picked);
                return { ok: true, changed: false, mode: 'drop', laneChanged: true };
              }
              return { ok: true, changed: false, mode: 'drop' };
            });
        }
      }
      return Promise.resolve({ ok: true, changed: false, mode: current });
    }
    if (target === 'drop' && !isDropAvailable()) {
      return Promise.resolve({ ok: false, changed: false, mode: current, reason: 'drop-unavailable' });
    }

    /* Entering kit — kit-progress owns the whole flow (focus modal,
       cart→kit migration, events). We just record the outcome. */
    if (target === 'kit') {
      var kp = getKp();
      if (!kp || typeof kp.setKitBuildMode !== 'function') {
        return Promise.resolve({ ok: false, changed: false, mode: current, reason: 'kit-progress-unavailable' });
      }
      var enableOpts = { source: opts.source || 'shop-mode' };
      if (typeof opts.focus !== 'undefined') enableOpts.focus = opts.focus;
      transitioning = true;
      return kp.setKitBuildMode('on', enableOpts).then(function (res) {
        transitioning = false;
        if (res && res.cancelled) {
          return { ok: true, changed: false, mode: current, cancelled: true };
        }
        if (!res || res.ok === false) {
          return { ok: false, changed: false, mode: current };
        }
        commit(current, 'kit', opts.source);
        return { ok: true, changed: true, mode: 'kit' };
      }, function () {
        transitioning = false;
        return { ok: false, changed: false, mode: current };
      });
    }

    /* Leaving kit for shop/drop — canonical OFF flow first. */
    if (current === 'kit') {
      transitioning = true;
      return leaveKit(opts).then(function (res) {
        if (res.cancelled) {
          transitioning = false;
          return { ok: true, changed: false, mode: 'kit', cancelled: true };
        }
        if (!res.ok) {
          transitioning = false;
          return { ok: false, changed: false, mode: 'kit' };
        }
        /* Drop entry runs the lane gate (R2); enterDrop releases the
           transitioning guard itself once the outcome is known. */
        if (target === 'drop') return enterDrop('kit', opts);
        transitioning = false;
        commit('kit', target, opts.source);
        return { ok: true, changed: true, mode: target };
      });
    }

    /* shop → drop — lane gate (subscriber tier / stored focus /
       mandatory entry modal). */
    if (target === 'drop') {
      transitioning = true;
      return enterDrop(current, opts);
    }

    /* drop → shop — plain flip, no kit involvement. */
    commit(current, target, opts.source);
    return Promise.resolve({ ok: true, changed: true, mode: target });
  }

  /* Subscribe / unsubscribe sugar — same wrapper shape as
     kitProgress.subscribe. */
  function subscribe(handler) {
    if (typeof handler !== 'function') return function () {};
    var wrapped = function (e) { handler(e.detail || {}); };
    document.addEventListener('hgn:shop-mode:change', wrapped);
    return function () { document.removeEventListener('hgn:shop-mode:change', wrapped); };
  }

  /* Reconcile with kit flips that bypass this module (kit-bar switch,
     product-card auto-on, UTM kit boot, another tab). Kit ON always
     records 'kit'; kit OFF while we recorded 'kit' falls back to
     'shop' (never silently to 'drop' — re-entering drop is an
     explicit choice). No-ops mid-set() so orchestrated transitions
     commit exactly once. */
  document.addEventListener('hgn:kit-build-mode:change', function (e) {
    if (transitioning) return;
    var to = e.detail && e.detail.to;
    var stored = readStored();
    if (to === 'on' && stored !== 'kit') {
      commit(stored, 'kit', 'kit-sync');
    } else if (to === 'off' && stored === 'kit') {
      commit('kit', 'shop', 'kit-sync');
    }
  });

  /* Fix F5 (second arm): kit mode engaging from ANY source (kit-bar
     switch, card auto-on, UTM boot) cancels an open/pending lane
     modal — the two entry modals share a z-plane and a late lane pick
     must never commit drop mode underneath an active kit build.
     Deliberately NOT gated on `transitioning` (a stray modal should
     die even mid-orchestration; cancel resolution is idempotent). */
  document.addEventListener('hgn:kit-build-mode:change', function (e) {
    if (e.detail && e.detail.to === 'on') closeLaneModal('__cancel__');
  });

  /* Cross-tab sync — mirror kit-progress's storage listener. */
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key !== storageKey()) return;
    var mode = get();
    applyBodyClass(mode);
    emitChange(null, mode, 'storage');
  });

  /* Initial body-class stamp. Deferred to DOMContentLoaded when the
     snippet runs from <head> before <body> exists. */
  function stampInitial() { applyBodyClass(get()); }
  if (document.body) stampInitial();
  else document.addEventListener('DOMContentLoaded', stampInitial, { once: true });

  window.HGN = window.HGN || {};
  window.HGN.shopMode = {
    get:             get,
    set:             set,
    subscribe:       subscribe,
    isDropAvailable: isDropAvailable,
    hasTesterFlag:   hasTesterFlag
  };
  /* R2 — the Nail Drop entry modal (kitFocusModal peer) + the shared
     per-box price formatter every Drop exposition surface uses. */
  window.HGN.dropLaneModal = dropLaneModal;
  window.HGN.formatDropPrice = formatDropPrice;
})();
